// units/actions.js

import { getAllUnits } from "../../api/AppDataApi";
import { unitsInitialState } from "./unitsState";

export const makeUnitsActions = (set, get) => ({
  fetchUnits: async () => {
    set((s) => ({ units: { ...s.units, loading: true, error: null } }));
    try {
      const data = await getAllUnits();
      set((s) => ({ units: { ...s.units, loading: false, list: data } }));
    } catch (err) {
      set((s) => ({
        units: { ...s.units, loading: false, error: err.message },
      }));
      console.error("Unit loading error:", err);
    }
  },
  resetUnits: () => set({ units: unitsInitialState }),
});
